// import { GDTApiErrors } from '@/types';
import { GDTApiErrors } from '@/types';
import { EditDataPost, ResponseEditarDatosTO } from '@/types/editProfile';
import axiosGdt from '@/utils/axiosGdt';
import { axiosErrorHandler } from '@/utils/functions';
import { URLs } from '@/utils/urls';

export const getProfileData = axiosErrorHandler(async () => {
  const url = URLs.PROFILE.PERSONAL_DATA;
  const response = await axiosGdt.get<ResponseEditarDatosTO>(url);
  return await response.data;
});

export const savePersonalData = axiosErrorHandler(
  async (value: EditDataPost) => {
    const url = URLs.PROFILE.PERSONAL_DATA;
    const response = await axiosGdt.post<ResponseEditarDatosTO>(url, value, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
    return response.data;
  },
  'Error al grabar registro'
);

export const changeTeamName = axiosErrorHandler(
  async (value: { nombreEquipo: string }) => {
    const url = URLs.PROFILE.TEAM_NAME;
    const response = await axiosGdt.post<GDTApiErrors>(url, value, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
    return response.data;
  }
);
